import { useState, useEffect } from "react";
import PageBase from "../PageBase/PageBase";
import { useParams } from "react-router-dom";
import { useApi } from "../../api/api";
import { PlanDataProvider } from "../../contexts/providers/PlanDataProvider";
import "../../styles/insightCards.css";

export default function Plan() {
  const { regionSlug, planSlug } = useParams();
  const { getPlansBySlugs } = useApi();
  const [planId, setPlanId] = useState(null);
  const [planName, setPlanName] = useState('');

  useEffect(() => {
    const fetchPlan = async () => {
      if (!regionSlug || !planSlug) return;
      try {
        const plansResponse = await getPlansBySlugs(regionSlug, planSlug);
        const plans = plansResponse?.data;
        const plan = Array.isArray(plans)
          ? plans.find(p => (p.fishery_management_plan_slug || p.slug) === planSlug)
          : plans;
        const planIdNum = plan?.fishery_management_plan_id ?? plan?.id ?? null;
        const name = plan?.name ?? plan?.fishery_management_plan_name ?? '';
        setPlanId(planIdNum);
        setPlanName(name);
      } catch (err) {
        console.error('Error fetching plan:', err);
        setPlanId(null);
        setPlanName('');
      }
    };
    fetchPlan();
  }, [regionSlug, planSlug, getPlansBySlugs]);

  return (
    <PlanDataProvider regionSlug={regionSlug} planSlug={planSlug}>
      <PageBase
        pageType="plan"
        resourceId={planId}
        leftPanelTitle="Fishery Management Adjustments"
        rightPanelTitle={planName ? `${planName} FMP Performance` : 'FMP Performance'}
        panelLayoutProps={{}}
        topPanelModules={null}
        bottomPanelVisible={true}
      />
    </PlanDataProvider>
  );
}
